module.exports = __webpack_public_path__ + "media/images/flags/16/Montserrat-fe9bcf823177faa7c2fee4e2804bea66.png";